import {
  AdminAppAction,
  CreatePageErrorAction,
  CreatePageRequestAction,
  CreatePageSuccessAction,
  PageActionType,
  createPageError,
  createPageSuccess,
} from '../../actions';
import {
  CREATE_PAGE_MUTATION,
  CreatePagePayload,
  CreatePageVariables,
} from '../../mutations';
import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '../epic-dependencies';
import { LIST_PAGES_QUERY } from '../../queries';
import { Observable } from 'rxjs';
import { PagesState } from '../../state';
import { switchMap } from 'rxjs/operators';
import template from 'string-template';

export const createPageEpic: Epic<
  AdminAppAction,
  CreatePageSuccessAction | CreatePageErrorAction,
  PagesState,
  EpicDependencies
> = (
  action$,
  state,
  { client },
): Observable<CreatePageSuccessAction | CreatePageErrorAction> =>
  action$.pipe(
    ofType<AdminAppAction, CreatePageRequestAction>(
      PageActionType.CreatePageRequest,
    ),
    switchMap(async (action: CreatePageRequestAction) => {
      const { data, errors } = await client.mutate<
        CreatePagePayload,
        CreatePageVariables
      >({
        errorPolicy: 'all',
        refetchQueries: [{ query: LIST_PAGES_QUERY }],
        mutation: CREATE_PAGE_MUTATION,
        variables: {
          input: {},
        },
      });

      if (errors) {
        return createPageError(action.pageKey, errors);
      } else if (data) {
        return createPageSuccess(
          action.pageKey,
          { id: data.createPage.page.id },
          action.redirect
            ? {
                redirect: {
                  to: template(action.redirect.to, data.createPage.page),
                  type: action.redirect.type,
                },
              }
            : undefined,
        );
      } else {
        throw new Error('No data.');
      }
    }),
  );
